import { Component, OnInit, Inject } from '@angular/core';
import { _, StepComponent, SharedFacade, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { EventBusService } from '@icc/shared';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared/config';

@Component({
    selector: 'icc-awning-systems-info',
    templateUrl: './awning-systems-info.component.html',
    styleUrls: ['./awning-systems-info.component.scss'],
    standalone: false
})
export class AwningSystemsInfoComponent extends StepComponent implements OnInit {
    public configurator = 'window';
    public stepId = 'systemInfo';
    public title = _('AWNING|Informacja na temat produktu');
    public options = [];

    system: any = null;

    constructor(
        private eventBusService: EventBusService,
        private sharedFacade: SharedFacade,
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        @Inject(ICC_PAGE_DATA) private pageData: {
            system: any
        }
    ) {
        super();
    }

    ngOnInit() {
        this.system = this.pageData.system;
    }

    close() {
        this.sharedFacade.closePage(true);
    }
}
